import Header from './components/Header'
import {Navigation} from './components/Navigation'
import {
    PageContainer,
    PageContent,
    PageHeader,
    PageFooter,
} from 'features/common/components/mobile/Page'
import {Outlet} from 'react-router-dom'

const PortalRoot = () => {
    return (
        <PageContainer>
            <div className="hide-scrollbar flex flex-1 flex-col overflow-auto">
                <PageHeader>
                    <Header />
                </PageHeader>

                <PageContent>
                    <div className="relative flex min-h-0 flex-1 overflow-hidden">
                        <Outlet />
                    </div>
                </PageContent>
            </div>
            <PageFooter>
                <Navigation />
            </PageFooter>
        </PageContainer>
    )
}

export default PortalRoot
